import { useEffect, useState } from 'react';
import { useTranslation } from '@klv/hooks/useTranslation';

import { calculateTimeRemaining, getTimestampInTimezone } from '@klv/shared/utils/dates';
import type { ITimeRemaining } from '@klv/shared/utils/dates/types';
import * as styles from './styles/countdownHero.module.css';

import CountdownUnit from './countdownUnit';
import type { ICountdownTimer } from './types';

const CountdownTimer = ({ countdown, setDisplayed }: ICountdownTimer ) => {

  const { t } = useTranslation();
  
  // try to use Intl or fall back to the translation file.
  const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || t('langCodes_timezone');
  const timestamp = getTimestampInTimezone(timezone, countdown);

  const [timeRemaining, setTimeRemaining] = useState<ITimeRemaining>(calculateTimeRemaining(timezone, timestamp));

  useEffect(() => {
    const timer = setInterval(() => {
      const timeLeft = calculateTimeRemaining(timezone, timestamp);
      // if we're out of time, setDisplayed to false and do not update the local state
      if (
        timeLeft.days === '00' && 
        timeLeft.hours === '00' && 
        timeLeft.minutes === '00' && 
        timeLeft.seconds === '00'
      ) {
        setDisplayed(false);
      }
      // if there is time left, set time remaining.
      setTimeRemaining(timeLeft);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (<>
    <div className={styles.scrollAnimation}>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.days} maxDigit={0}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_days')}</span>
      </div>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.hours} maxDigit={24}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_hours')}</span>
      </div>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.minutes} maxDigit={60}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_minutes')}</span>
      </div>
      <div className={styles.timeIncrement}>
      <CountdownUnit baseDigit={timeRemaining.seconds} maxDigit={60}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_seconds')}</span>
      </div>
    </div>
    <div className={styles.scrollAnimation}>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.days} maxDigit={0}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_days')}</span>
      </div>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.hours} maxDigit={24}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_hours')}</span>
      </div>
      <div className={styles.timeIncrement}>
        <CountdownUnit baseDigit={timeRemaining.minutes} maxDigit={60}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_minutes')}</span>
      </div>
      <div className={styles.timeIncrement}>
      <CountdownUnit baseDigit={timeRemaining.seconds} maxDigit={60}/>
        <span className={styles.countdownText}>{t('organisms_countdownHero_seconds')}</span>
      </div>
    </div>
  </>)
};

export default CountdownTimer;
